import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getAlGroupsForDropdown,
    getDivisionByEstateID,
    GetAllOperationEntityByGroupID,
    BestPluckerPerfromanceReportData
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getDivisionByEstateID(operationEntityID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true && item[1]["operationEntityID"] == operationEntityID) {
            array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return array;
}



async function BestPluckerPerfromanceReportData(data) {
    var model = {
        groupID: data.groupID,
        estateID: data.estateID,
        collectionPointID: data.collectionPointID,
        pluckingType: data.pluckingType,
        fromDate: data.fromDate,
        toDate: data.toDate
    };
    const response = await CommonPost('/api/BestPluckerPerfromanceReport/GetDataForBestPluckerPerfromanceReport', null, model);

    return response.data;
}

